import { useEffect, useState } from "react";
import Card from "../Card";

const TraficWidget = ({ icon, title, subtitle }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(subtitle) || 0; 
    if (start === end) return;

    let incrementTime = 20; 
    const step = Math.ceil(end / 50); 

    const timer = setInterval(() => {
      start += step;
      if (start >= end) {
        start = end;
        clearInterval(timer);
      }
      setCount(start);
    }, incrementTime);

    return () => clearInterval(timer);
  }, [subtitle]);

  return (
    <Card extra={`rounded-[20px] cursor-pointer`}>
      <div className={"flex items-center rounded-[20px]"}>
        <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
          <div className="rounded-full p-3 bg-[#f8e6ef]">
            <span className="flex items-center text-[#c51369]">{icon}</span>
          </div>
        </div>

        <div className="h-50 ml-4 flex w-auto flex-col justify-center">
          <p className={"font-dm text-sm font-medium tracking-wide"}>
            {title}
          </p>
          <h4 className={"text-xl font-bold dark:text-white tracking-wider"}>
            {count}
          </h4>
        </div>
      </div>
    </Card>
  );
};

export default TraficWidget;
